import React, { useCallback, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Headings,
  Button,
  Paragraph,
  ExternalLinkIcon,
} from '@sentara-health/optimahealth_web';
import { ANALYTICS_MESSAGES, domainForSegment } from 'common';
import { useAdobeAnalytics } from '@sentara-health/platform-analytics';

//  Initialize useTranslation hook

interface CommonClaimsProps {
  staticUrlLink: string;
  claimTitle: string;
  claimMsg: string;
  analyticsFeatureName: string;
}

const CommonClaims: React.FC<CommonClaimsProps> = ({
  staticUrlLink,
  claimTitle,
  claimMsg,
  analyticsFeatureName,
}) => {
  const { t } = useTranslation();
  const { contentListingItemClicked } = useAdobeAnalytics();
  const effectRan = useRef(false);

  const trackContentListing = useCallback(
    (contentId: string, contentTitle: string, itemPosition: number) => {
      contentListingItemClicked({
        segment: `${domainForSegment}${window.location.pathname}`,
        contentListing: {
          eventType: 'Content Listing Item Clicked',
          listing: {
            content: [{ contentId, contentTitle, itemPosition }],
          },
        },
      });
    },
    [contentListingItemClicked]
  );

  useEffect(() => {
    if (effectRan.current) return;
    trackContentListing(
      '1001',
      `${analyticsFeatureName}_${ANALYTICS_MESSAGES.SSO_INTERSTITIAL_PAGE_LOAD}`,
      1
    );
    effectRan.current = true;
  }, [analyticsFeatureName, trackContentListing]);

  return (
    <>
      <div className="mb-4">
        <Headings
          level={1}
          text={claimTitle}
          variant="semiBold"
          dataTestId="pharmacyHeader"
        />
      </div>
      <div className="pharmacy_claims_wrapper mb-4">
        <Paragraph
          text={claimMsg}
          variant="regular"
          data-testid="pharmacyClaimsText"
        />
        <div className="d-flex align-items-center">
          <Button
            dataTestId={'continueNavigate'}
            onClick={() => {
              trackContentListing(
                '1004',
                `${analyticsFeatureName}_${ANALYTICS_MESSAGES.SSO_LAUNCH_SUCCESS}`,
                4
              );
              window.open(staticUrlLink, '_blank');
            }}
            iconRight={<ExternalLinkIcon />}
            variant="link_btn"
            iconStroke="none"
          >
            {t('common.continue')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default CommonClaims;
